import { useContext } from "react";
import { DashboardContext } from "../context/dashboard-context";

const useDashboard = () => useContext(DashboardContext);

export default useDashboard;
